import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { Card, CardHeader, Collapse } from 'reactstrap';

const column1 = [
  {
    Header: 'Item Description',
    accessor: 'itemDesc',
    width: 300,
  },
  {
    Header: 'supplement Data Description ',
    accessor: 'suppDataDesc',
    style: { whiteSpace: 'unset' },
  },
];

const Header = data => {
  const [toggleQuestion, setToggequestion] = useState(1);

  return (
    <div className="nf-u-details__grid">
      <Card className="nf-solicitation-detail__card">
        <CardHeader
          className="nf-solicitation-detail__card-header"
          onClick={() => setToggequestion(!toggleQuestion)}
        >
          Item Description {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
        </CardHeader>

        <Collapse isOpen={toggleQuestion}>
          <ReactTable
            data={data.block}
            columns={column1}
            defaultPageSize={data.block.length > 0 ? data.block.length : 3}
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
        </Collapse>
      </Card>
      {/* <Table dataSource={drawings} columns={columns} /> */}
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/niinDetailTables/ItemDescription.jsx